<script lang="ts">
	import type { Answer, Question } from "./types/shared";
	import Summary from "./Summary.svelte";
	import { PortableText } from "@portabletext/svelte";
	import { contentBlockComponents } from "@ishavskraft/shared";
	import { page } from "$app/state";

	let { answer }: { answer: Answer | Question } = $props();

	let isOpen = $state(false);

	$effect(() => {
		if (
			"answer" in answer &&
			!("question" in answer) &&
			page.url.hash === `#${encodeURIComponent(answer.title)}`
		) {
			isOpen = true;
		}
	});
</script>

{#if "question" in answer}
	<details class="mx-4">
		<Summary link class="text-base">{answer.question}</Summary>
		<div class="mx-4">
			<PortableText value={answer.answer} components={contentBlockComponents} />
		</div>
	</details>
{:else if "answer" in answer}
	<details class="mx-4" bind:open={isOpen}>
		<Summary link class="text-base">{answer.title}</Summary>
		<div class="mx-4" id={answer.title}>
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html answer.answer}
		</div>
	</details>
{/if}

<style lang="postcss">
	details:not(:last-child):after {
		content: "";
		display: block;
		border: 1px solid var(--primary-dark);
		margin-block: var(--s-3);
	}
</style>
